import { Box, Button, CircularProgress, Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserService from '../../../services/user.service';
import useAlert from '../../../hooks/useAlert';
import useAuth from '../../../hooks/useAuth';

export default function ContactMethodVerification(props: {
  contactMethodVerificationId: number;
  contactMethodVerificationType: string;
  firstName?: string;
  lastName?: string;
}) {
  const { contactMethodVerificationId, contactMethodVerificationType, firstName, lastName } = props;

  const auth = useAuth();
  const navigate = useNavigate();
  const { setAlert, clearAlert } = useAlert();

  const [code, setCode] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const verifyAuthChallenge = async () => {
    clearAlert();

    try {
      setLoading(true);
      const response = await UserService.verifyAuthChallenge(
        contactMethodVerificationType,
        contactMethodVerificationId,
        code,
        firstName,
        lastName,
      );
      await auth.login(response.data.userId, response.data.accessToken);
      navigate('/');
    } catch (error: any) {
      setAlert({
        message: error.response?.data?.error || 'Failed to create account.',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container direction={'column'} spacing={2} sx={styles.mainContainer}>
      <Grid item>
        <TextField
          value={code}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setCode(event.target.value)}
          placeholder='Code'
          type='text'
          required
        />
      </Grid>
      <Grid item sx={{ width: 1 }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Button variant={'outlined'} onClick={verifyAuthChallenge}>
            Submit
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    columnGap: 2,
    padding: 2,
  },
};
